@let exchangeRate = exRateService.exRate$ | async;
@let currencyCode = showCurrency ? (exchangeRate?.SYMBOL ?? "") : "";
<div class="balance-display">
  <mat-icon (click)="balanceService.refreshExposure()" class="refresh-icon" [ngClass]="{ 'refresh-spin': $loading | async }">refresh</mat-icon>
<!--  @if (isDev) {-->
<!--    <select class="wallet-select">-->
<!--      <option>Main Wallet</option>-->
<!--      <option>Casino Wallet</option>-->
<!--    </select>-->
<!--  }-->
  <div class="value-pair">
    <span class="balance-label text-balance">{{ "Balance" | translate }}:&nbsp;</span>
    <span class="balance-value text-balance balance-val">{{ currencyCode }}&nbsp;{{ balance | number: "1.2-2" }}</span>
  </div>
  <div class="lr-divider"></div>
  <div class="value-pair">
    <span class="balance-label text-balance">{{ "Exposure" | translate }}:&nbsp;</span>
    <span class="balance-value text-balance exposure-val">{{ currencyCode }}&nbsp;{{ totalExposure | number: "1.2-2" }}</span>
  </div>
  <div class="middle-divider"></div>
  <div class="value-pair">
    <span class="balance-label text-balance">{{ "Avl. to bet" | translate }}:&nbsp;</span>
    <span class="balance-value text-balance exposure-val">{{ currencyCode }}&nbsp;{{ availableToBet | truncateNumber }}</span>
  </div>
  <div class="lr-divider"></div>
  <app-user-button />
</div>
